










































































































































import Vue from 'vue';
import { required, sameAs } from 'vuelidate/lib/validators';

import { api, MEMBER_API_SUB_URLS } from '@/api';

import { lengthRange, password } from '@/validations';

import { CloseFullscreenWrapper, FormValidation, OpenHelp } from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenLoading,
  FullscreenSuccess,
  FullscreenError,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { AccountUpdatePasswordFormModel } from '@/@types/member';
import PasswordValidationIcon from '../../auth-tools/registration/password-status.component.vue';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
  confirmBeforeClose: boolean;
  changeMade: boolean;
  formValid: boolean;
  formModel: AccountUpdatePasswordFormModel;
  isPasswordVisible: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  OpenHelp,
).extend({
  name: 'UpdatePassword',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
      confirmBeforeClose: true,
      changeMade: false,
      formValid: false,
      formModel: {
        token: '',
        password: '',
        confirmPassword: '',
      },
      isPasswordVisible: false,
    };
  },
  beforeMount() {
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      token: {
        required,
      },
      password: {
        lengthRange: lengthRange(15, 256),
        pwFirstChar: password.firstChar,
        pwValidChars: password.validChars,
        pwRepeatingChars: password.repeatingChars,
        pwAlphaNumericChars: password.alphaNumeric,
        pwSpecialChar: password.specialChar,
        pwUpperLower: password.upperLower,
        required,
      },
      confirmPassword: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },
  computed: {
    // VALIDATION MESSAGES
    tokenErrors(): string[] {
      const formField = 'formModel.token';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'global_form-error_token_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      if (this.errorMessage !== this.params.errorMessage) {
        // We need user to start over and request a new token
        this.closeFullscreenWrapper();
        return;
      }
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
      this.errorMessage = this.params.errorMessage;
    },
    submitForm(): void {
      this.isLoading = true;

      // REST 095
      api
        .post(
          `${MEMBER_API_SUB_URLS.members}/${
            this.$store.getters.user.memberId
          }/update-password`,
          {
            password: this.formModel.password,
            secureToken: this.formModel.token,
          },
        )
        .then(() => {
          this.showSuccessMessage = true;
          this.isLoading = false;
          this.changeMade = false;

          // GTM Event - Update Password
          window.dataLayer.push({
            event: 'updatePassword',
          });
        })
        .catch((error) => {
          if (error.status === 403) {
            this.errorMessage = this.params.errorMessageTokenInvalid;
          } else if (error.message === 'Password has previously been used') {
            this.errorMessage = this.params.errorMessagePasswordReused;
          } else if (error.message === 'Password cannot contain user ID, first name, or last name') {
            this.errorMessage = this.params.errorMessagePasswordName;
          } else if (error.message === 'Password cannot change more than once in 24 hours.') {
            this.errorMessage = this.params.errorMessagePasswordAge;
          }

          this.showErrorMessage = true;
          this.isLoading = false;
          this.changeMade = false;
        });
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenLoading,
    FullscreenSuccess,
    FullscreenError,
    PasswordValidationIcon,
  },
});
